import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LoginButton from "./LoginButton";
import { connect } from "react-redux";
import * as userActions from "../redux/actions/userActions";

function NavMenu() {
  return (
    <>
      <Nav className="mr-auto">
        <Nav.Link
          as={NavLink}
          to={{ pathname: "/add" }}
          exact
          activeStyle={{
            fontWeight: "bold",
            color: "yellow",
          }}
        >
          New Question
        </Nav.Link>
        <Nav.Link
          as={NavLink}
          exact
          to={{ pathname: "/leaderboard" }}
          activeStyle={{
            fontWeight: "bold",
            color: "yellow",
          }}
        >
          Leader Board
        </Nav.Link>
        <About />
      </Nav>
    </>
  );
}
function LoggedState(params:{isLogged:any,avatar:any}) {
  if (params.isLogged === true) {
    return (
      <>
        <NavMenu />
        <img src={params.avatar} className="userAvatar" alt="avatar" />
      </>
    );
  } else {
    return <About />;
  }
}
function About() {
  return (
    <Nav className="mr-auto">
      <Nav.Link
        as={NavLink}
        to={{ pathname: "/about" }}
        exact
        activeStyle={{
          fontWeight: "bold",
          color: "yellow",
        }}
      >
        About
      </Nav.Link>
    </Nav>
  );
}
function MyNavbar(props:any) {
  props.getAllUsers();
  return (
    <Navbar bg="dark" variant="dark" className="navHeight">
      <Container>
        <Navbar.Brand
          as={NavLink}
          exact
          to={{ pathname: "/" }}
          activeStyle={{
            fontWeight: "bold",
            color: "yellow",
          }}
        >
          Home
        </Navbar.Brand>

        <LoggedState
          isLogged={props.isLogged}
          avatar={props.loggedUser.avatarURL}
        />
        <LoginButton />
      </Container>
    </Navbar>
  );
}
const mapDispatchToProps = (dispatch:any) => {
  return {
    getAllUsers: () => dispatch(userActions.getAllUsers()),
  };
};
const mapStateToProps = (state:any) => {
  return {
    loggedUser: state.userReducer.loggedUser,
    isLogged: state.userReducer.loggedUser.id ? true : false,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyNavbar);
